import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import { AppCrashedFallback } from 'components/FatalError/AppCrashFallback';
import { UserPreferencesLoadingErrorModal } from 'components/userPreferences/UserPreferencesLoadingErrorModal';
import { Layout } from 'layouts/Layout';
import { FC, PropsWithChildren } from 'react';
import { AppRouter } from 'routes/AppRouter';

export const AppRoot: FC<{ Router: FC<PropsWithChildren> }> = ({ Router }) => (
  <GenericErrorBoundary Fallback={AppCrashedFallback}>
    <UserPreferencesLoadingErrorModal>
      <Router>
        <Layout>
          <AppRouter />
        </Layout>
      </Router>
    </UserPreferencesLoadingErrorModal>
  </GenericErrorBoundary>
);
